module.exports = __webpack_public_path__ + "img/cute_natural_doodle_5.a5c3338c.png";